import { useState } from "react";

const WHATSAPP_NUMBER = "971500000000"; // UAE number — update to real number
const WHATSAPP_MESSAGE = encodeURIComponent(
  "Hi! I found you on SuperMiddleEast Factory & Buyer. I'd like to inquire about factories and products."
);

const WhatsAppButton = () => {
  const [hovered, setHovered] = useState(false);

  const handleClick = () => {
    window.open(
      `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  return (
    <button
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      aria-label="Contact us on WhatsApp"
      className="fixed right-4 z-40 cursor-pointer flex items-center gap-2 transition-all duration-300"
      style={{ bottom: "calc(64px + 16px)" }}
    >
      {/* Tooltip label — shows on hover (desktop) or always visible on mobile */}
      <span
        className={`
          hidden sm:flex whitespace-nowrap bg-white border border-green-200 text-green-700
          text-xs font-semibold px-3 py-1.5 rounded-full shadow-sm
          transition-all duration-300
          ${hovered ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2"}
        `}
      >
        Chat on WhatsApp
      </span>

      {/* Green circle button */}
      <div
        className={`
          w-13 h-13 rounded-full flex items-center justify-center shadow-lg
          bg-green-500 hover:bg-green-600 transition-all duration-300
          ${hovered ? "scale-110" : "scale-100"}
        `}
        style={{ width: "52px", height: "52px" }}
      >
        {/* Pulse ring */}
        <span className="absolute w-13 h-13 rounded-full bg-green-400 animate-ping opacity-30 pointer-events-none"
          style={{ width: "52px", height: "52px" }}
        />
        <i className="ri-whatsapp-line text-white text-2xl relative z-10" />
      </div>
    </button>
  );
};

export default WhatsAppButton;